/*  Variable
   ========================================================================== */
/*  breakpoint
   ========================================================================== */
/*  Misc
   ========================================================================== */
/*  Section Colors
   ========================================================================== */
/*  The Big Guns
   ========================================================================== */
/*  The Next Wave
   ========================================================================== */
/*  Start Ups
   ========================================================================== */
/*  Future Tech
   ========================================================================== */
/*  Reviewed
   ========================================================================== */
/*  Tried & Tested
   ========================================================================== */
/*  Digital Life
   ========================================================================== */
/*  Other Colors
   ========================================================================== */
/*  Generic Colors
   ========================================================================== */
/*  Article Body Colors
   ========================================================================== */
/*  Footer
   ========================================================================== */
/*  AMP
   ========================================================================== */
#app .modal-body {
  height: calc(100vh - 113px);
  height: var(calc(--window-height), calc( - 113px));
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0;
  -webkit-overflow-scrolling: touch;
}
#app .modal-dialog {
  width: 100%;
  /* Mobile breakpoints */
  /* Mobile breakpoints */
  max-width: 390px;
  overflow-y: initial !important;
  float: right;
}
@media (min-width: 0) and (max-width: 1023px) {
#app .modal-dialog {
      max-width: 100%;
}
}
@media (min-width: 768px) and (max-width: 1023px) {
#app .modal-dialog {
      max-width: 390px;
}
}
#app .modal-dialog .modal-content {
    /* Mobile breakpoints */
    /* Mobile breakpoints */
    width: 100%;
    max-width: 390px;
}
@media (min-width: 0) and (max-width: 1023px) {
#app .modal-dialog .modal-content {
        max-width: 100%;
}
}
@media (min-width: 768px) and (max-width: 1023px) {
#app .modal-dialog .modal-content {
        max-width: 390px;
}
}
#app #tech-lift-modal {
  width: 100vw;
  left: inherit;
}
#app #tech-lift-modal.modal.fade .modal-dialog {
    -webkit-transform: translate(300px, 0);
        -ms-transform: translate(300px, 0);
            transform: translate(300px, 0);
}
#app #tech-lift-modal.modal.show .modal-dialog {
    -webkit-transform: translate(0);
        -ms-transform: translate(0);
            transform: translate(0);
}
#app #tech-lift-modal .modal-dialog {
    margin: 0;
}
#app #tech-lift-modal .modal-dialog .modal-content {
      background-color: #222222;
}
#app #tech-lift-modal .modal-dialog .modal-content .modal-header {
        border: none;
}
#app #tech-lift-modal .modal-dialog .modal-content .modal-header-wrapper {
        padding-bottom: 0.875rem;
}
#app #tech-lift-modal .tech-lift-footer {
    height: 19.875rem;
}
#app .modal-menu-overlay {
  opacity: 0;
}
#app .modal-menu-overlay.active {
    -webkit-transition: opacity .5s;
    -o-transition: opacity .5s;
    transition: opacity .5s;
    background-color: #000000;
    opacity: 0.7;
    position: fixed;
    top: 0;
    height: 100%;
    width: 100%;
}



// WEBPACK FOOTER //
// ./components/app-shell/Modal.vue